import React, { useContext } from 'react'
import Input from '../inputs/Input'
import FormGrid from '../layouts/FormGrid'
import PageTitle from '../layouts/PageTitle'
import useSteps from '../../hooks/useSteps'
import NextStepButton from '../utils/NextStepButton'
import InputWrap from '../inputs/InputWrap'
import PrevStepButton from '../utils/PrevStepButton'
import { AdOrderContext } from '../../contexts/AdOrder'
import { getFieldConfig  } from '../../utils/FieldSettings'

export default function ContactInformation () {
  const { nextStep } = useSteps()
  const { fieldSettings } = useContext(AdOrderContext)

  const nameField = getFieldConfig(fieldSettings, 'name', {
    title: 'Navn på bestiller',
    placeholder: 'Indtast fulde navn',
    required: true,
  })

  const companyField = getFieldConfig(fieldSettings, 'company_name', {
    title: 'Navn på firma/forening',
    placeholder: 'Indtast navn på firma/forening',
    required: true,
  })

  const vatField = getFieldConfig(fieldSettings, 'cvr', {
    title: 'CVR-nr',
    placeholder: 'Indtast CVR-nr',
    required: true,
  })

  const emailField = getFieldConfig(fieldSettings, 'mail', {
    title: 'Mail',
    placeholder: 'Indtast mail',
    required: true,
  })

  const phoneField = getFieldConfig(fieldSettings, 'phone', {
    title: 'Telefonnr',
    placeholder: 'Indtast nr',
    required: true,
  })

  return (
    <>
      <PageTitle step={1} />
      <FormGrid>
        <Input
          name="name"
          subobj="contact"
          label={nameField.title}
          placeholder={nameField.placeholder}
          labelExtraText={nameField.text}
          required={nameField.required}
          autocomplete="name"
        />
        <Input
          name="company_name"
          subobj="contact"
          label={companyField.title}
          placeholder={companyField.placeholder}
          labelExtraText={companyField.text}
          required={companyField.required}
          size="half"
          autocomplete="organization"
        />
        <Input
          name="vat"
          subobj="contact"
          label={vatField.title}
          placeholder={vatField.placeholder}
          labelExtraText={vatField.text}
          required={vatField.required}
          size="half"
        />
        <Input
          name="email"
          subobj="contact"
          label={emailField.title}
          placeholder={emailField.placeholder}
          labelExtraText={emailField.text}
          required={emailField.required}
          size="half"
          type="email"
          autocomplete="email"
        />
        <Input
          name="phone"
          subobj="contact"
          label={phoneField.title}
          placeholder={phoneField.placeholder}
          labelExtraText={phoneField.text}
          required={phoneField.required}
          size="half"
          type="tel"
          autocomplete="tel"
        />
        <InputWrap>
          <div className="ad-next-step">
            <PrevStepButton label="Tilbage" style="outline-dark arrow-flipped" />
            <NextStepButton label="Gå til betaling" style="secondary" />
          </div>
        </InputWrap>
      </FormGrid>
    </>
  )
}
